<script>
    import DraftSwatch from "../../../Store/DraftSwatch";
    import Color       from "../../../../../Lib/Color";

    export default {
        name: "BaseColorInput",

        props: {
            value: {}
        },

        computed: {
            color() {

            }
        },

        data() {
            return {
                draft: new DraftSwatch(),
            };
        },

        methods: {
            /**
             * get a color value in whatever format it wants.
             * update a property on it (field)
             * update the draft.
             */
            updateField(event, field) {
                let color    = this.getValue();
                color[field] = event.target.value;

                let sanitizedColor = this.getSanitizedColor(color);

                if(sanitizedColor) {
                    this.draft.setAll(sanitizedColor, this.colorType);
                }
            },
        },
    }
</script>
